import BaseView from '../../BaseView';
import hbs from 'handlebars-inline-precompile';

export default BaseView.extend({
  template: hbs('\
    <div class="okta-form-infobox-error infobox infobox-error" role="alert">\
      <span class="icon error-16"></span>\
      {{#if errorSummary}}\
        <p>{{errorSummary}}</p>\
      {{else}}\
        <p>{{i18n code="oform.errorbanner.title" bundle="courage"}}</p>\
      {{/if}}\
    </div>\
  '),
  modelEvents: {
    'form:clear-errors': 'remove'
  }
});



// WEBPACK FOOTER //
// ./node_modules/@okta/courage/src/views/forms/helpers/ErrorBanner.js


// WEBPACK FOOTER //
// webpack:///node_modules/@okta/courage/src/views/forms/helpers/ErrorBanner.js